import axios from 'axios';
import config from '../variables/config';

export const REQUEST_SENT = 'giftcards/REQUEST_SENT';
export const MESSAGE_SHOWN = 'giftcards/MESSAGE_SHOWN';
export const REQUEST_FAILED = 'giftcards/REQUEST_FAILED';
export const REQUEST_FINISHED = 'giftcards/REQUEST_FINISHED';
export const FETCH_REQUEST = 'giftcards/FETCH_REQUEST';
export const SET_ID = 'giftcards/SET_ID';

const initialState = {
  data: [],
  newGiftcardId: null,
  requestFailed: false,
  requestLoading: false,
  requestFinished: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false,
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        requestFinished: true,
        requestLoading: false,
        data: action.giftcards,
      }

    case MESSAGE_SHOWN:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    case FETCH_REQUEST:
      return {
        ...state,
        newGiftcardId: null,
        requestLoading: false,
        data: action.giftcards,
      }

    case SET_ID:
      return {
        ...state,
        newGiftcardId: action.id,
      }

    default:
      return state
  }
}

export const fetchGiftcards = (showAlert) => {
  return async (dispatch, getState) => {
    const token = getState().admin.token;
    try {
      dispatch({ type: REQUEST_SENT });

      const giftcards = (await axios.get(config.serverURL + '/Giftcards?access_token=' + token)).data;
      if (Array.isArray(giftcards)) {
        if (showAlert) {
          dispatch({ type: REQUEST_FINISHED, giftcards: giftcards });
        } else {
          dispatch({ type: FETCH_REQUEST, giftcards: giftcards });
        }
      } else {
        dispatch({ type: REQUEST_FAILED });
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED });
    }
  }
}

export const updateGiftcard = (data) => {
  return async (dispatch, getState) => {
    const token = getState().admin.token;

    try {
      dispatch({ type: REQUEST_SENT });
      const url = config.serverURL + '/Giftcards/' + data.id + '?access_token=' + token;
      const giftcard = (await axios.patch(url, data.properties)).data;
      if (giftcard.id) {
        dispatch(fetchGiftcards())
      } else {
        dispatch({ type: REQUEST_FAILED });
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED });
    }
  }
}

export const createGiftcard = (data) => {
  return async (dispatch, getState) => {
    const token = getState().admin.token;

    try {
      dispatch({ type: REQUEST_SENT });

      const giftcard = (await axios.post(config.serverURL + '/Giftcards?access_token=' + token, data)).data;
      if (giftcard.id) {
        dispatch({ type: SET_ID, id: giftcard.id });
        dispatch(fetchGiftcards(true));
      } else {
        dispatch({ type: REQUEST_FAILED });
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED });
    }
  }
}

export const setDefaults = () => {
  return dispatch => {
    dispatch({ type: MESSAGE_SHOWN });
  }
}
